import script from "./VariableRateTooltip.vue?vue&type=script&setup=true&lang=ts"
export * from "./VariableRateTooltip.vue?vue&type=script&setup=true&lang=ts"

import "./VariableRateTooltip.vue?vue&type=style&index=0&id=5c4aad76&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\src\\ApplicantPortal.Web\\clientapp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5c4aad76"]])

export default __exports__